module.exports = {
	hash: require('./lib/scrypt-async'),
	hashSync: require('./lib/scrypt-sync')
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/js-scrypt/index.js
// module id = 511
// module chunks = 0